import React from 'react'

import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import MessageBanner from 'components/Luxkit/Banners/MessageBanner'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import Group from 'components/utils/Group'
import MyTripsEmpty from 'tripPlanner/pages/myTrips/MyTripsEmpty'
import MyTripsListGrid from 'tripPlanner/pages/myTrips/MyTripsListGrid'
import { BasicTrip } from 'tripPlanner/types/common'

interface Props {
  status: 'error' | 'success' | 'loading'
  trips: Array<BasicTrip> | undefined
  onRequestRefetch: () => void
}

function TripsTab({ status, trips, onRequestRefetch }: Props) {
  return (
    <ModalContent>
      <Group direction="vertical" gap={32}>
        {status === 'loading' && <LoadingIndicator inline />}
        {status === 'success' && (!trips || trips.length === 0) && (
          <MyTripsEmpty />
        )}
        {status === 'error' && (
          <MessageBanner
            kind="critical"
            description="Failed to fetch trips"
            primaryActionButtonProps={{
              children: 'Retry',
              onClick: onRequestRefetch,
            }}
          />
        )}
        {trips && trips.length > 0 && (
          <MyTripsListGrid
            trips={trips}
            source="trip_drawer"
            isVisibleCreateNewTripTile={false}
            className="drawer"
          />
        )}
      </Group>
    </ModalContent>
  )
}

export default TripsTab
